(function() {
	'use strict';

	angular.module('leaveReport').config(config);

	function config($stateProvider) {
		$stateProvider.state('leaveReport', {
			url : '/leave-report',
			views : {
				'leaveReportView' : {
					templateUrl : 'leave-report/views/leave-report.tpl.html',
					controller : 'LeaveReportCtrl',
					controllerAs : 'leaveReport'
				}
			}
		});
	}
}());
